import actionTypes from '../actions'
import { DialogMode } from '../../constants'

const initialState = {
  dialogMode: DialogMode.NONE,
  codatConnected: false,
  errorNotification: false,
  financialOverviewDaySpan: 30,
  errorState: false,
  isOpenSubscriptionModal: false,
  isOpenCompanyNameModal: false,
  accountCodatConnected: false,
  commerceCodatConnected: false,
  commerceConnectionId: '',
  accountConnectionId: '',
}

const reducer = (state = initialState, action) => {
  if (action.type === actionTypes.SHOWFINANCEDIALOG) {
    return {
      ...state,
      dialogMode: DialogMode.FINANCE,
    }
  }
  if (action.type === actionTypes.HIDEDIALOG) {
    return {
      ...state,
      dialogMode: DialogMode.NONE,
    }
  }
  if (action.type === actionTypes.SHOWSALESDIALOG) {
    return {
      ...state,
      dialogMode: DialogMode.SALES,
    }
  }
  if (action.type === actionTypes.CODATDISCONNECTED) {
    return {
      ...state,
      codatConnected: false,
    }
  }

  if (action.type === actionTypes.ACCOUNTCODATDISCONNECTED) {
    return {
      ...state,
      accountCodatConnected: false,
      accountConnectionId: '',
    }
  }

  if (action.type === actionTypes.COMMERCECODATDISCONNECTED) {
    return {
      ...state,
      commerceCodatConnected: false,
      commerceConnectionId: '',
    }
  }

  if (action.type === actionTypes.ACCOUNTINGCODATCONNECTED) {
    return {
      ...state,
      accountCodatConnected: action.data,
    }
  }

  if (action.type === actionTypes.ACCOUNTINGCONNECTIONID) {
    return {
      ...state,
      accountConnectionId: action.data,
    }
  }

  if (action.type === actionTypes.COMMERCECODATCONNECTED) {
    return {
      ...state,
      commerceCodatConnected: action.data,
    }
  }

  if (action.type === actionTypes.COMMERCECONNECTIONID) {
    return {
      ...state,
      commerceConnectionId: action.data,
    }
  }

  if (action.type === actionTypes.CODATCONNECTED) {
    return {
      ...state,
      codatConnected: true,
    }
  }
  if (action.type === actionTypes.SHOWERRORNOTIFICATION) {
    return {
      ...state,
      errorNotification: true,
    }
  }
  if (action.type === actionTypes.HIDEERRORNOTIFICATION) {
    return {
      ...state,
      errorNotification: false,
    }
  }
  if (action.type === actionTypes.SETFINANCIALOVERVIEWDAYSPAN) {
    return {
      ...state,
      financialOverviewDaySpan: action.data,
    }
  }
  if (action.type === actionTypes.SETERRORSTATE) {
    return {
      ...state,
      errorState: action.data,
    }
  }
  if (action.type === actionTypes.TOGGLESUBSCRIPTIONMODAL) {
    return {
      ...state,
      isOpenSubscriptionModal: action.data,
    }
  }
  if (action.type === actionTypes.TOGGLECOMPANYNAMEMODAL) {
    return {
      ...state,
      isOpenCompanyNameModal: action.data,
    }
  }
  if (action.type === actionTypes.RESET_APP_STATE) {
    return { ...initialState }
  }
  return state
}

export default reducer
